import React from "react";
import "../CSS/onlineOrdering.css";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import logo from "../Assets/command-line.png";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Accordion from "react-bootstrap/Accordion";
import ButtonBoot from "react-bootstrap/Button";

const buttonStyle = {
  marginTop: "20px",
  backgroundColor: "rgb(20, 150, 255)",
  outline: "none",
  padding: "20px",
  fontWeight: "500",
  borderRadius: "10px",
  color: "white",
  width: "60%",
};

class Ordering extends React.Component {
  render() {
    return (
      <div class="ordering">
        <Navbar expand="lg" className="nav navbarFront" fixed="top">
          <Link to="/">
            <Navbar.Brand className="navtitle" style={{ margin: "10px" }}>
              <img
                src={logo}
                className="logoIcon"
                alt="Compile Labs Logo - Mobile/Web Design and Development"
              />
            </Navbar.Brand>
          </Link>

          <Navbar.Brand className="navtitle">Compile Labs</Navbar.Brand>

          <Nav className="ml-auto">
            <Link to="/">
              <Nav className="linkButton" style={{ marginRight: "10px" }}>
                Home
              </Nav>
            </Link>

            <Link to="/contact">
              <Nav className="linkButton mobNo">Contact Us</Nav>
            </Link>
          </Nav>
        </Navbar>
        <div class="videoArea">
          <video class="videoClip" autoPlay playsInline muted loop>
            <source
              src="https://compilelabs.s3.ca-central-1.amazonaws.com/videos/restaurantsMobileAppMin.mp4"
              type="video/mp4"
            />
            <source
              src="https://compilelabs.s3.ca-central-1.amazonaws.com/videos/restaurantsMobileAppMin.mp4"
              type="video/ogg"
            />
          </video>
          <div class="videoTitle">Welcome Shop Owners</div>
        </div>

        <Container className=" text-center">
          <div className="spacingMod" id="more">
            <Row>
              <Col md={7}>
                <div
                  className="weDoTitleOrdering servicesArea"
                  data-aos={"fade"}
                >
                  We build custom branded apps and websites for you!
                </div>
                <div className="weDo servicesArea" data-aos={"fade"}>
                  Building an app for your restaurant or store does not have to
                  be a long and expensive process, we specialize in
                  affordability and time management. Our designed focused
                  approach differentiates us from common apps out there using
                  the same template over and over again,
                </div>
              </Col>

              <Col md={5} data-aos={"fade-up"}>
                <img
                  src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/mockup1.jpg"
                  className="itemsImage"
                />
              </Col>
            </Row>
          </div>
          <div class="spacing50 test" data-aos={"fade"}>
            <Row>
              <Col md={12}>
                <div className="titleProcessOrder">Why Compile Labs?</div>
              </Col>
              <Col md={3} className="text-left">
                <div className="whyBox">
                  <CountUp end={70} redraw={true}>
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} className="titleNumbersOrder" />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  <span class="numbersSub">%</span>
                  <div class="itemsOrderingTitleNumber">
                    Customers Preference
                  </div>
                  <div class="itemsTextOrdering">
                    70% of customers prefer to order directly from a restaurant
                    rather than using a 3rd party app. Get a quote to get yours
                    now.
                  </div>
                </div>
              </Col>

              <Col md={3} className="text-left">
                <div className="whyBox">
                  <CountUp end={3} redraw={true}>
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} className="titleNumbersOrder" />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  <span class="numbersSub">wks</span>
                  <div class="itemsOrderingTitleNumber">Development Cycle</div>
                  <div class="itemsTextOrdering">
                    We develop apps fast, we can design, develop and deploy your
                    online ordering app in less than a month with top quality.
                  </div>
                </div>
              </Col>

              <Col md={3}>
                <div className="whyBox">
                  <div className="titleNumbersOrder">Free</div>
                  <div class="itemsOrderingTitleNumber">Interactive Design</div>
                  <div class="itemsTextOrdering">
                    We start the client process by sharing with you a design of
                    your app prior to any payment, if you like it we then
                    proceed to develop it.
                  </div>
                </div>
              </Col>
              <Col md={3}>
                <div className="titleNumbersOrder">Unlimited</div>
                <div class="itemsOrderingTitleNumber">App Revisions</div>
                <div class="itemsTextOrdering">
                  We go over your app as many times as you want until you feel
                  satisfied with the final product.
                </div>
              </Col>
              <Col md={12} className="noPad">
                <div className="darkBack">
                  <img
                    src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
                    className="imageBanner"
                  />
                </div>
                <div className="withinImage">
                  <div className="imageTitle">Passionate Developer</div>
                  <div className="imageText">
                    I am a passionate developer with a strong attention to all
                    details.
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div class="spacing50" data-aos={"fade"}>
            <Row>
              <Col md={12}>
                <div className="titleProcessOrder">Pricing structure.</div>
              </Col>

              <Col md={4}>
                <div class="itemsBorderSpecial">
                  <div class="itemsBox">
                    <div class="itemsTextPricing">
                      <div class="itemsOrderingTitle">Monthly</div>
                      <div class="itemsOrderingPriceDiscount">$350</div>
                      <div class="itemsOrderingPrice">$250</div>
                      <div class="itemsTextOrdering">
                        This is the more affordable and flexible plan to get
                        your app built. We will charge $250 on a monthly basis
                        which includes any new changes and maintenance.
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={4}>
                <div class="itemsBorder">
                  <div class="itemsBox">
                    <div class="itemsTextPricing">
                      <div class="itemsOrderingTitle">Per Feature</div>
                      <div class="itemsOrderingPrice">$150</div>
                      <div class="itemsTextOrdering">
                        This plan is best when you already have an app or
                        website developed and want to improve or add features.
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={4}>
                <div class="itemsBorder">
                  <div class="itemsBox">
                    <div class="itemsTextPricing">
                      <div class="itemsOrderingTitle">Single Scope</div>
                      <div class="itemsOrderingPrice">Custom</div>
                      <div class="itemsTextOrdering">
                        This works best for apps that are single-page or don't
                        require any databases, for example, menu apps, promotion
                        apps, etc.
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={12} style={{ marginTop: "30px" }}>
                <Link to="/contact">
                  <Button
                    variant="contained"
                    disableElevation
                    style={buttonStyle}
                  >
                    Request a Demo
                  </Button>
                </Link>
              </Col>
            </Row>
          </div>
          <div class="spacing50" data-aos={"fade"}>
            <Row>
              <Col md={12}>
                <div className="titleProcessOrder">
                  What your app will contain.
                </div>
              </Col>
              <Col md={4}>
                <div className="willContainBox">
                  <img
                    src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/credit-card.png"
                    className="itemsIcons"
                  />
                  {/* Icon by Vector Market */}
                  <div class="itemsTextArea">
                    <div class="itemsOrderingTitleContains">
                      Online Payments
                    </div>
                    <div class="itemsTextOrderingContains">
                      We can integrate a system where your customers can make
                      payments online, making the whole purchasing experience
                      better.
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="willContainBox">
                  <img
                    src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/content.png"
                    className="itemsIcons"
                  />
                  {/* Icon by Adib Sulthon */}
                  <div class="itemsTextArea">
                    <div class="itemsOrderingTitleContains">Custom Design</div>
                    <div class="itemsTextOrderingContains">
                      We offer free designs for our customer, once they approve
                      we get to work turning that design into an app.
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="willContainBox">
                  <img
                    src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/statistics.png"
                    className="itemsIcons"
                  />
                  {/* Icon by Freepik */}
                  <div class="itemsTextArea">
                    <div class="itemsOrderingTitleContains">
                      Store Analytics
                    </div>
                    <div class="itemsTextOrderingContains">
                      We offer a store analytics dashboard where a store can
                      easily manage, study and modify their products and their
                      trends.
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="willContainBox">
                  <img
                    src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/notification.png"
                    className="itemsIcons"
                  />
                  {/* Icon by Freepik */}
                  <div class="itemsTextArea">
                    <div class="itemsOrderingTitleContains">
                      Live Notifications
                    </div>
                    <div class="itemsTextOrderingContains">
                      We offer a live notification system for any new incoming
                      orders so you can stay in the loop in real time.
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="willContainBox">
                  <img
                    src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/map.png"
                    className="itemsIcons"
                  />
                  {/* Icon by Freepik */}
                  <div class="itemsTextArea">
                    <div class="itemsOrderingTitleContains">
                      Location System
                    </div>
                    <div class="itemsTextOrderingContains">
                      The user will be able to locate your store and you will be
                      able to locate them for deliveries.
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="willContainBox">
                  <img
                    src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/star.png"
                    className="itemsIcons"
                  />
                  {/* Icon by Freepik */}
                  <div class="itemsTextArea">
                    <div class="itemsOrderingTitleContains">Rating System</div>
                    <div class="itemsTextOrderingContains">
                      Know your customers by having a rating system in your app,
                      you can see what your customers like most.
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div class="spacing50" data-aos={"fade"}>
            <Row>
              <Col md={12}>
                <div className="titleProcessOrder">Learn more.</div>
              </Col>

              <Col md={12}>
                <Link to="/contact">
                  <Button
                    variant="contained"
                    disableElevation
                    style={buttonStyle}
                  >
                    Request a Demo
                  </Button>
                </Link>
                <div className="titleSubLearn">
                  Or email us at{" "}
                  <a href="mailto:support@compilelabs.io" className="email">
                    support@compilelabs.io
                  </a>{" "}
                </div>
              </Col>
            </Row>
          </div>

          <div class="spacing50" data-aos={"fade"}>
            <Row>
              <Col md={12}>
                <div className="titleProcessOrder">
                  Frequently asked questions.
                </div>
              </Col>

              <Col md={6} className="text-left">
                <Accordion>
                  <Row>
                    <Col md={12} className="itemMob" data-aos={"fade-up"}>
                      <Accordion.Toggle
                        as={ButtonBoot}
                        variant="link"
                        eventKey="1"
                        className="itemsTitleQuestion"
                      >
                        Why should I choose Compile Labs?{" "}
                        <i class="arrow down" id="image"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="1">
                        <div className="innerBoxTextAnswers">
                          There are many companies around the world doing what
                          we are doing, but we are the only ones that provide a
                          top quality product for a small price point. The
                          reason for that is our origin, we are a fairly new
                          company that only started in 2020, and after the
                          pandemic hit we saw an opportunity to flex our talent
                          muscles and compile up the best developers and
                          business consultants we know.
                          <br></br> <br></br>
                          Along with that, simply put, we love what we do, we
                          created Compile Labs to create beautiful products and
                          make them as affordable as possible so more people can
                          enjoy them.
                        </div>
                      </Accordion.Collapse>
                    </Col>
                    <Col md={12} className="itemMob" data-aos={"fade-up"}>
                      {/* <img src={calendar}  className="itemIcon" /> */}
                      <Accordion.Toggle
                        as={ButtonBoot}
                        variant="link"
                        eventKey="0"
                        className="itemsTitleQuestion"
                      >
                        How involved should I be in the development process?{" "}
                        <i class="arrow down"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <div className="innerBoxTextAnswers">
                          Your involvement will vary depending on the project
                          scope, but usually we just need you to be present once
                          during the initial planning for approval of our given
                          design, once every week during development, and once
                          at the end of development before deployment.
                        </div>
                      </Accordion.Collapse>
                    </Col>

                    <Col md={12} className="itemMob" data-aos={"fade-up"}>
                      {/* <img src={staticPage}   className="itemIcon" /> */}
                      <Accordion.Toggle
                        as={ButtonBoot}
                        variant="link"
                        eventKey="2"
                        className="itemsTitleQuestion"
                      >
                        How fast can we get started on the project?{" "}
                        <i class="arrow down"></i>
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey="2">
                        <div className="innerBoxTextAnswers">
                          As soon as you send us a quote we will be happy to
                          start things off by sending you a project proposal,
                          upon review and approval, we then send you your own
                          app design, with your pictures and logos which you
                          must provide.
                        </div>
                      </Accordion.Collapse>
                    </Col>
                  </Row>
                </Accordion>
              </Col>

              <Col md={6} className="text-left">
                <Accordion>
                  <Row>
                    <Col md={12} className="itemMob" data-aos={"fade-up"}>
                      {/* <img src={calendar}  className="itemIcon" /> */}
                      <Accordion.Toggle
                        as={ButtonBoot}
                        variant="link"
                        eventKey="0"
                        className="itemsTitleQuestion"
                      >
                        How does the payment structure work?{" "}
                        <i class="arrow down"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <div className="innerBoxTextAnswers">
                          The payment structure will depend on the type of
                          payment you decide to choose, this will be decided
                          when you contact us and receive a quote from us.
                        </div>
                      </Accordion.Collapse>
                    </Col>
                    <Col md={12} className="itemMob" data-aos={"fade-up"}>
                      <Accordion.Toggle
                        as={ButtonBoot}
                        variant="link"
                        eventKey="1"
                        className="itemsTitleQuestion"
                      >
                        How much does a single scope project cost?{" "}
                        <i class="arrow down"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="1">
                        <div className="innerBoxTextAnswers">
                          A single scope project varies, but if you want a
                          online order and delivery style app for solely your
                          restaurant, then it will cost around $5k to $20k.
                        </div>
                      </Accordion.Collapse>
                    </Col>
                  </Row>
                </Accordion>
              </Col>
            </Row>
          </div>
        </Container>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default Ordering;
